import { render, staticRenderFns } from "./tournamentsSlider.vue?vue&type=template&id=6da54fde&scoped=true&"
import script from "./tournamentsSlider.vue?vue&type=script&lang=js&"
export * from "./tournamentsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da54fde",
  null
  
)

export default component.exports